import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Header from "./Header"
import Container from "./Container"
import TextWrapper from "./TextWrapper"
import ImageWrapper from "./ImageWrapper"
import H1 from "../typography/H1"
import P from "../typography/P"
import InternalButton from "./InternalButton"
import H4 from "../typography/H4"
import { brandAccentColor } from "../../theme"
import FlexDiv from "./FlexDiv"

const HeroVideo = ({
  tint,
  topTitle,
  title,
  description,
  link,
  media,
  whiteText,
  clipPath,
  buttonSubText,
  buttonText,
  imageHalf,
  alignItems,
  fullWidthButton,
  customClass,
  customInternalButton,
  features,
  headerClassName,
  button2Text,
  button2Link,
  customInternalDemoButton,
}) => (
  <Header tint={tint} clipPath={clipPath} className="mobile-app-header">
    <Container alignItems={alignItems} className={customClass}>
      <TextWrapper>
        {topTitle && <H4>{topTitle}</H4>}
        <H1 whiteText={whiteText} className={headerClassName}>
          {title}
        </H1>
        {description}
        {features}
        <div>
          <FlexDiv fxGap="25px">
            <InternalButton
              className={`trialButton ${customInternalButton}`}
              to={link}
              color={brandAccentColor}
              fullWidth={fullWidthButton}
              marginBottom={button2Text && button2Link ? "0" : "20px"}
            >
              {buttonText}
            </InternalButton>
            {button2Text && button2Link && (
              <InternalButton
                className={`trialButton demoButton ${customInternalDemoButton}`}
                color={"#233343"}
                fullWidth={fullWidthButton}
                onClick={() => {
                  window.open(button2Link, "_blank", "noopener,noreferrer")
                  return false
                }}
              >
                {button2Text}
              </InternalButton>
            )}
          </FlexDiv>
          {buttonSubText && (
            <SubText whiteText={whiteText}>{buttonSubText}</SubText>
          )}
        </div>
      </TextWrapper>
      <ImageWrapper half={imageHalf}>{media}</ImageWrapper>
    </Container>
  </Header>
)

HeroVideo.propTypes = {
  tint: PropTypes.bool,
  topTitle: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  descriptionLine2: PropTypes.string,
  link: PropTypes.string,
  media: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  whiteText: PropTypes.bool,
  buttonSubText: PropTypes.string,
  buttonText: PropTypes.string,
  button2Text: PropTypes.string,
  imageHalf: PropTypes.bool,
}

HeroVideo.defaultProps = {
  tint: false,
  topTitle: "",
  title: "Hero Title",
  description: "",
  descriptionLine2: "",
  link: "/pricing",
  whiteText: false,
  buttonSubText: "",
  buttonText: "Get Started",
  imageHalf: false,
}

export default HeroVideo

const SubText = styled(P)`
  ${({ theme }) => theme.desktop`
font-size: 17px;
  `};
`
